/** Український номер з БД (380XXXXXXXXX) у вигляді +380 (XX) XXX-XX-XX; інше — як є */
export function formatPhone(raw: string): string {
    const digits = raw.replace(/\D/g, '')
    const m = digits.match(/^380(\d{2})(\d{3})(\d{2})(\d{2})$/)
    return m ? `+380 (${m[1]}) ${m[2]}-${m[3]}-${m[4]}` : raw
}
